export const DETECT_OS_ENDPOINT = {
    detectOsUrl: {
      url: '/v1/os-detect',
      method: 'GET',
    },
}